
import React from 'react'
import PropTypes from 'prop-types';

import {servidor, servicioRestful, nombreCliente, VERSION, intervaloComprobacionServidor} from './Configuracion'
import ClienteRestful from "../framework/ClienteRestful";
import connect from "react-redux/es/connect/connect";
import "./resources/css/formulariomarcaje.css"
import {estadoChangeConexion} from "./redux/estado/actions"
import {CONEXION_CONECTADO, CONEXION_DESCONECTADO} from "./redux/estado/actions";
import {getMinutosEntreDates, getFormattedTimeFromTimestamp} from "../framework/DateUtils";

class BarraEstado extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fechahoraServidor: null,
            diferenciaMinutosFechaServidor: 0,
        }
    }

    componentDidMount() {
        this.getServerTime();

        //setInterval(() => this.getServerTime(),10000 );
        setInterval(() => {
            console.log("Barra conexion");
            this.getServerTime()
        },intervaloComprobacionServidor * 1000);
    }


    getServerTime= () => {
        console.log("serverTime");
        let url= servidor + "time/servertime";
        console.log("url: ", url);
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doGet(response => {
            let fechahoraServidor= new Date(response.iso8601);
            let fechahoraLocal= new Date();
            let minutosDiferencia= getMinutosEntreDates(fechahoraLocal, fechahoraServidor);
            console.log(minutosDiferencia);
            this.props.dispatch(estadoChangeConexion(CONEXION_CONECTADO));
            this.setState({fechahoraServidor: fechahoraServidor, diferenciaMinutosFechaServidor: minutosDiferencia});
            },
            response => {
            this.props.dispatch(estadoChangeConexion(CONEXION_DESCONECTADO));
            this.setState({fechahoraServidor: null, diferenciaMinutosFechaServidor: 0});
            }
        );
    }

    comprobarEstado= () => {

        let urlPost= servidor;
        const clienteRestful = new ClienteRestful().setUrl(urlPost);
        clienteRestful.doGet(
            response => {
                        //console.log("CONEXION: OK");
                        this.props.dispatch(estadoChangeConexion(CONEXION_CONECTADO));
                        },
            response => {
                        //console.log("CONEXION: CANCEL");
                        this.props.dispatch(estadoChangeConexion(CONEXION_DESCONECTADO));
                    }
        );

    }

    render() {
        const {fechahoraServidor, diferenciaMinutosFechaServidor} = this.state;
        const {estado} = this.props;
        //console.log("Render");
        //console.log(diferenciaMinutosFechaServidor);
        //console.log(diferenciaMinutosFechaServidor > 5);
        return (
            <div className= { estado.conexion === CONEXION_CONECTADO ? "barraEstadoConectado" : "barraEstadoDesconectado" }>
                {estado.conexion === CONEXION_CONECTADO ? "Conectado a " + nombreCliente : "Desconectado de " + nombreCliente}
                {fechahoraServidor && diferenciaMinutosFechaServidor > 5 &&
                <div>Hora del servidor: {getFormattedTimeFromTimestamp(fechahoraServidor)} - Tiene más de 5 minutos de diferencia respecto a la hora local</div>}
            </div>
        )
    }
}


BarraEstado.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        estado: state.estado,
    }
}

export default connect(mapStateToProps)(BarraEstado);
